import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../services/AxiosInstance";
import {
    JWT_TOKEN,
    USER_EMAIL_ID,
    USER_ID,
    USER_NAME,
    USER_ORG_ID,
} from "../Constants/StorageConstants";
import { USERS_URL } from "../Constants/Constants";
import { AuthContext } from "../App";

const SsoRedirect = () => {
    const navigate = useNavigate();
    const ranOnce = useRef(false);
    const { updateAuthStatus } = useContext(AuthContext);

    useEffect(() => {
        if (ranOnce.current) return; // 🛑 prevent second run
        ranOnce.current = true;

        const params = new URLSearchParams(window.location.hash.substring(1));
        const token = params.get("token");
        const userId = params.get("id");

        if (!token || !userId) {
            navigate("/login", { replace: true });
            return;
        }

        // Clear old session
        localStorage.clear();

        // Save JWT
        localStorage.setItem(JWT_TOKEN, token);

        // Clean URL
        window.history.replaceState({}, "", "/sso-redirect");

        // Load user profile
        AxiosInstance.get(`${USERS_URL}/${encodeURIComponent(userId)}`).then(
            (response) => {
                var userData = response.data.data;
                localStorage.setItem(USER_NAME, userData.name);
                localStorage.setItem(USER_ID, userData.id);
                localStorage.setItem(USER_ORG_ID, userData.orgId);
                localStorage.setItem(USER_EMAIL_ID, userData.emailId);
            }).finally(() => {
                updateAuthStatus();
                navigate("/home", { replace: true });
            });

        // AxiosInstance.get("/api/users/" + userId)
        //     .then((res) => {
        //         const user = res.data;
        //         localStorage.setItem("USER_ID", user.id);
        //         localStorage.setItem("USER_NAME", user.name);
        //         localStorage.setItem("USER_ORG_ID", user.orgId);
        //         localStorage.setItem("USER_EMAIL_ID", user.emailId);
        //     })
        //     .finally(() => {
        //         navigate("/home", { replace: true });
        //     });
    }, [navigate]);

    return <div>Signing you in…</div>;
};

export default SsoRedirect;